import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPwaAppr: () => {
		return client
			.get(`${BASE_URL}/mqy/ceqi/pwaAppr/v1/claim`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
